import React from 'react';

import {GenericSidebarItemType} from 'app/components/general/GenericAttachedItemsSidebar/RTKGenericAttachedItemsSidebar';
import {
  convertLocationParamsToFetchParams,
  usePolicies,
} from 'app/policies/api';
import {QuizGenericObjectsSidebar} from 'app/quizzes/components/QuizDetailPage/QuizGenericObjectsSidebar';
import {POLICIES_NEW_POLICY} from 'app/urls';

import type {DocumentContentType} from 'sweet-types';

type Props = {
  quizURL: string;
  quizId: string;
  canEdit: boolean;
  attachedItems: Array<GenericSidebarItemType>;
  onClose: () => void;
};

export const QuizPoliciesSidebar = ({
  quizURL,
  quizId,
  attachedItems,
  ...other
}: Props) => {
  const contentType: DocumentContentType = 'policy';
  const props = {
    quizId,
    quizURL,
    attachedItems,
    contentType,
    // create
    createURL: POLICIES_NEW_POLICY,
    onModelChange: () => [],
    useDataHook: usePolicies,
    paramsConverter: convertLocationParamsToFetchParams,
    ...other,
  };
  return <QuizGenericObjectsSidebar {...props} />;
};
